module.exports = __webpack_public_path__ + "media/images/vp/icon.menu.help.red-6f54198c3794eb24c306b57b29aec823.svg";